import { useUser } from "../../hooks/useUser";
import ApplicationNavbar from "../../components/ApplicationNavbar";
import Databases from "../../components/Databases";
import { LoginButton } from "../../components/Login";
import SignupButton from "../../components/SignupButton";


const Playground = () => {
    const user = useUser();
    const loggedIn = user.state === "LoggedIn";

    return (
        <div className="flex flex-col min-h-screen bg-gray-900 pt-16">
            <ApplicationNavbar />
            {loggedIn ? <Databases /> : <div>
                <div className="flex flex-col items-center justify-center h-screen">
                    <h1 className="text-4xl font-bold text-white">Welcome to the Oasis Playground</h1>
                    <p className="text-lg text-gray-300">Please login to continue</p>
                    <div className="flex flex-row gap-2">
                        <LoginButton className="bg-gray-800 text-white shadow-[0_0_0_3px_#ffffff_inset] border-white"/>
                        <SignupButton className="bg-gray-800 text-white shadow-[0_0_0_3px_#ffffff_inset] border-white"/>
                    </div>
                </div>
            </div>}
        </div>
    )
}

export default Playground;